import { render, staticRenderFns } from "./OrgCreate.vue?vue&type=template&id=67a423e4&scoped=true"
import script from "./OrgCreate.vue?vue&type=script&lang=js"
export * from "./OrgCreate.vue?vue&type=script&lang=js"
import style0 from "./OrgCreate.vue?vue&type=style&index=0&id=67a423e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a423e4",
  null
  
)

export default component.exports